export function initInterlock(root = document) {
  const interlocksArray = Array.from(root.querySelectorAll("[data-interlock]"));
  const interlocks = interlocksArray.reduce((acc, val) => {
    if (val.dataset.interlock in acc) {
      acc[val.dataset.interlock].push(val);
    }
    else {
      acc[val.dataset.interlock] = [ val ];
    }

    return acc;
  }, {});

  interlocksArray.forEach(item => {
    item.addEventListener("change", e => {
      for (const input of interlocks[item.dataset.interlock]) {
        input.disabled = true;
      }

      item.disabled = false;

      if (item.type === "text" && !item.value) {
        for (const input of interlocks[item.dataset.interlock]) {
          input.disabled = false;
        }
      }
    });

    item.addEventListener("interlock.reset", e => {
      for (const input of interlocks[item.dataset.interlock]) {
        input.disabled = false;
      }      
    });
  });
}
